<div>
</div>
<!--Modal - Home-->
<ng-template #modalcc let-modal>
  <button (click)="closeModal()" id="popup-modal-close-button" type="button" class="btn-close"
    aria-label="Close"></button>
  <div class="PopUp_content external-html">
    <img
      src="https://blobpuntoapunto.blob.core.windows.net/prod-puntoapunto-public/CondicionesComerciales/condiciones-comerciales-popup.jpg"
      alt="Encuesta de satisfacción 2024" class="img-fluid">
    <div class="text-center p-4">
      <h4 class="mb-5 w-90 mx-auto text-center">Acepta las Comunicaciones Comerciales para poder
        recibir las mejores ofertas y descuentos.
      </h4>
      <a href="my-zone/my-info" class="btn btn-blue btn-icon mb-5">
        ACEPTAR COMUNICACIONES COMERCIALES
      </a>
    </div>
  </div>
</ng-template>